import { render, staticRenderFns } from "./PatientFormActions.vue?vue&type=template&id=07b5d750"
import script from "./PatientFormActions.vue?vue&type=script&lang=js"
export * from "./PatientFormActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports